<template>
    <div ref="title" class="title-wrap">
      <h1>{{text}}</h1>
      <div class="line"></div>
    </div>
</template>

<script>
    export default {
        name: "v-title",
      props: ['text','color'],
      mounted() {
        this.$refs.title.style.color = this.color;
      }
    }
</script>

<style lang="less" scoped>
  .title-wrap {
    h1 {
      font-size: 2.25rem;
      text-align: center;
    }
    .line {
      width: 48px;
      height: 4px;
      margin: 20px auto 0;
      background-color: #0AD3FD;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/plug/VTitle.vue